// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useIsOperator } from '../../../contexts/ModuleContext';
import { OperatorConfigurations } from './OperatorConfigurations';

export const Configurations = () => {
  const isOperator = useIsOperator();
  return isOperator ? <OperatorConfigurations /> : null;
};
